/**
 * Add buttons to "Open all" and "Close all" elements inside an accordion
 *     - Get accordion Elements
 *     - Get toggle buttons
 *     - Add event listener to toggle buttons
 */
export default function tripAccordionInit() {
  const accordions = document.querySelectorAll('.trip-accordion');
  if (!accordions) return;

  accordions.forEach((accordion) => {
    accordion.toggleButton = accordion.querySelector('.trip-accordion__toggle');
    if (!accordion.toggleButton) return;

    accordion.globalState = false;
    accordion.panels = accordion.querySelectorAll('.accordion__panel');
    accordion.contents = accordion.querySelectorAll('.accordion__content');

    accordion.toggleButton.addEventListener('click', () => {
      handleToggleClick(accordion);
    })
  })
}

/**
 * When a toggle button is clicked:
 *     - Update the corresponding Accordion UI
 *     - Update the button UI
 *
 * @param accordion
 */
function handleToggleClick(accordion) {
  accordion.globalState = !accordion.globalState;
  updateAccordionUI(accordion, accordion.globalState);
  updateToggleUI(accordion.toggleButton, accordion.globalState);
}

/**
 * Update the button UI
 *     - Update attributes
 *     - Update button's text
 *
 * @param toggleButton
 * @param state
 */
function updateToggleUI(toggleButton, state) {
  const toggleButtonText = toggleButton.querySelector('.trip-accordion__button-content')
  if (state) {
    toggleButton.setAttribute('accordion-open', '');
    toggleButtonText.textContent = toggleButton.getAttribute('data-text-less');
  } else {
    toggleButton.removeAttribute('accordion-open');
    toggleButtonText.textContent = toggleButton.getAttribute('data-text-more');
  }
}

/**
 * Update the accordion UI
 *     - Update classes
 *     - Update aria-expanded attribute
 *
 * @param accordion
 * @param state
 */
function updateAccordionUI(accordion, state) {
  accordion.panels.forEach((panel) => {
    state
      ? panel.classList.add('accordion__panel--active')
      : panel.classList.remove('accordion__panel--active');

    panel.setAttribute("aria-expanded", state);
  });

  accordion.contents.forEach((accordionContent) => {
    state
      ? accordionContent.classList.add('accordion__content--active')
      : accordionContent.classList.remove('accordion__content--active');

    accordionContent.setAttribute("aria-expanded", "true");
  });
}
